import {createStore} from "vuex";
import invoice from "./invoice";
import segmentation from "./segmentation";
import session from "./session";
import booking from "./booking";

const store = createStore({
    modules: {
        invoice: invoice,
        segmentation: segmentation,
        session: session,
        booking: booking,
    }
})

export default store;
